<div class="container-fluid px-4 mt-4 mb-5">
    <div class="cp-page-header mb-3">
        <div class="cp-page-title"><i class="fa-solid fa-gear me-2"></i>Configuración</div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Inicio</a></li>
                <li class="breadcrumb-item active">Configuración</li>
            </ol>
        </nav>
    </div>

    <ul class="nav nav-pills cp-tabs mb-4">
        <li class="nav-item" *ngFor="let t of tabs">
            <a class="nav-link" [title]="t.purpose" [routerLink]="t.link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
                <i class="fa-solid {{ t.icon }} me-1"></i>{{ t.label }}
            </a>
        </li>
        <li class="nav-item ms-auto">
            <a class="nav-link" href="https://controlporteria.cl/descarga/app" target="_blank" rel="noopener" title="Descargar la app móvil">
                <i class="fa-solid fa-mobile-screen me-1"></i>Descargar la app
            </a>
        </li>
    </ul>

    <div class="cp-help mb-4">
        <button type="button" class="cp-help-toggle" (click)="helpOpen = !helpOpen" [attr.aria-expanded]="helpOpen">
            <i class="fa-solid fa-circle-info me-2"></i>¿Para qué sirve «{{ current.label }}»?
            <i class="fa-solid ms-auto" [ngClass]="helpOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
        </button>
        <div class="cp-help-body" *ngIf="helpOpen">
            <p class="mb-0">{{ current.purpose }}</p>
        </div>
    </div>

    <router-outlet></router-outlet>
</div>
